import Components from "slotworks/components/components";
import SlotDefinition from "slotworks/model/slot-definition";

export function SetAllLinesEffects(tint: number, filters: Array<PIXI.Filter<any>>) {
    for (let i = 1; i <= SlotDefinition.lines.values.length; i++) {
        if (filters.length) {
            Components.lines.filter(i, filters);
        } else {
            Components.lines.tint(i, tint);
        }
    }
}
